import React, { useState } from 'react';
import { fmt } from '../utils/api';

export default function MagiSnapshot({ data }) {
  const [collapsed, setCollapsed] = useState(true);
  if (!data) return null;

  const eligible = data.status !== 'over';
  const color = eligible ? '#00d4aa' : '#ef4444';

  return (
    <div style={styles.panel}>
      <button style={styles.header} onClick={() => setCollapsed((c) => !c)}>
        <h2 style={styles.title}>
          <span style={styles.chevron}>{collapsed ? '▸' : '▾'}</span>
          🏥 MAGI / ACA
        </h2>
        <span style={{ ...styles.badge, color, borderColor: color }}>
          {eligible ? '✓ Eligible' : '✗ Not Eligible'}
        </span>
      </button>

      {!collapsed && (
        <>
          <div style={styles.row}>
            <span style={styles.label}>Projected income</span>
            <span style={styles.value}>{fmt.currency(data.projectedYearEnd)}</span>
          </div>
          <div style={styles.row}>
            <span style={styles.label}>400% FPL limit</span>
            <span style={styles.value}>{fmt.currency(data.limits.fpl400)}</span>
          </div>
          <div style={styles.barTrack}>
            <div style={{
              ...styles.barFill,
              width: `${Math.min(data.projectedPctOf400, 100)}%`,
              background: color,
            }} />
          </div>
          <div style={styles.pctLabel}>{data.projectedPctOf400}% of limit</div>
        </>
      )}
    </div>
  );
}

const styles = {
  panel: {
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '16px',
    padding: '1.25rem',
  },
  header: {
    background: 'transparent',
    border: 'none',
    width: '100%',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.75rem',
    flexWrap: 'wrap',
    gap: '0.4rem',
  },
  chevron: {
    display: 'inline-block',
    color: '#6b7280',
    marginRight: '4px',
  },
  title: {
    margin: 0,
    fontSize: '0.9rem',
    fontWeight: '700',
    color: '#fff',
    fontFamily: "'Syne', sans-serif",
  },
  badge: {
    border: '1px solid',
    borderRadius: '999px',
    padding: '2px 10px',
    fontSize: '0.7rem',
    fontWeight: '700',
    fontFamily: "'Syne', sans-serif",
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.75rem',
    marginBottom: '0.3rem',
  },
  label: { color: '#6b7280', fontFamily: "'Syne', sans-serif" },
  value: { color: '#e5e7eb', fontFamily: "'DM Mono', monospace" },
  barTrack: {
    height: '5px',
    background: '#0a0f1e',
    borderRadius: '3px',
    overflow: 'hidden',
    marginTop: '0.5rem',
  },
  barFill: { height: '100%', borderRadius: '3px' },
  pctLabel: {
    color: '#4b5563',
    fontSize: '0.7rem',
    marginTop: '0.3rem',
    fontFamily: "'DM Mono', monospace",
  },
};
